<template>
<div>
  <nav :is="header"/>
  <router-view
  @showErrorModal="onError($event)"
  @showMessageModal="onMessage($event)"
  @showLoginModal="onLogin($event)"/>
  <footer-bar/>
  <error-modal style="display:none;" ref="errorModal">
    <ul v-if="isErrorMessageArray">
      <li v-for="msg in errorModalBody">{{ msg }}</li>
    </ul>
    <div v-else>{{ errorModalBody }}</div>
  </error-modal>
  <login-modal style="display:none;" ref="loginModal">
    <div v-if="loginModalCaption">{{ loginModalCaption }}</div>
  </login-modal>
  <message-modal style="display:none;" ref="messageModal">
    <div>{{ message }}</div>
  </message-modal>
</div>
</template>

<script>
import GlobalHeaderBar from './GlobalHeaderBar'
import LoginHeader from './LoginHeader'
import FooterBar from 'components/FooterBar'
import ErrorModal from 'components/ErrorModal'
import LoginModal from 'components/lecturer/LoginModal'
import MessageModal from 'components/lecturer/MessageModal'
import util from 'util/common'
export default {
  name: 'app',
  components: {
    GlobalHeaderBar,
    LoginHeader,
    FooterBar,
    ErrorModal,
    LoginModal,
    MessageModal
  },
  data () {
    return {
      errorModalBody: '',
      loginModalCaption: '',
      message: ''
    }
  },
  computed: {
    header () {
      return util.endsWith(this.$route.path, '/login') ||
      util.endsWith(this.$route.path, '/password') ||
      util.startsWith(this.$route.path, '/email/edited/')
       ? 'login-header' : 'global-header-bar'
    },
    isErrorMessageArray () {
      return util.isArray(this.errorModalBody)
    }
  },
  methods: {
    onError (ev) {
      this.errorModalBody = ev
      this.$refs.errorModal.showModal()
    },
    onLogin (ev) {
      this.loginModalCaption = ev
      this.$refs.loginModal.showModal()
    },
    onMessage (ev) {
      this.message = ev
      this.$refs.messageModal.showModal()
    }
  }
}
</script>

<style lang="scss">
@import "../../scss/style.scss";
</style>



// WEBPACK FOOTER //
// App.vue?c7f0bdc0